import React, {useState} from 'react';
import {MenuButton} from '../Utils.js'
import { 
    Grid,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
} from "@chakra-ui/react"
import {personRegister} from '../../Data.js';
import {PersonDetails} from '../SectorOverview/PersonDetails.js';
import {BackgroundTitle} from '../Backgrounds.js';

function PersonHeader(props) {
    return (
        <div className="text-container shadow-light" style={{height: props.height}}>
            <svg style={{position:"absolute"}}  width={props.width} height={props.height}>
                <BackgroundTitle height={props.height} width={props.width}/>
            </svg>
            <div style={{left: props.height+10}} className="text-centered-vertical Text-Standard Text-MissionHeader">{props.text}</div>
        </div>
    );
}

export function PersonScreen(props) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [ person, setPerson ] = useState({});
    let buttons = personRegister.map( (p_person, i) => {       
        return (
            <MenuButton key={"personButton"+i} height={70} width={900} state={""} setActive={() => {
                onOpen();
                setPerson(p_person);
            }}
            id={i} active={false} text={p_person.name}></MenuButton>
        );
        }   
    );

    const fullWidth = 1101;
    const fullHeight = 600; 
    const gridGap = 24;


    if (props.enabled) {
        return (
            <div>
                <Grid 
                    gap="10px"
                    padding="15px"
                    margin="10px"
                >
                    {buttons}
                </Grid>
                <Modal isOpen={isOpen} onClose={ () => 
                    {
                        onClose();
                    }
                }
                isCentered>
                    <ModalOverlay />
                    <ModalContent maxWidth={fullWidth + gridGap*2} backgroundColor="rgba(37, 40, 41,0.95)" border="1px solid rgba(240, 248, 255, 0.3)">
                        <ModalHeader> 
                            <PersonHeader
                                height = {70}
                                width = {fullWidth - 40}
                                text = {person.name}></PersonHeader>
                        </ModalHeader>
                        <ModalCloseButton color="white" size="lg" />
                        <ModalBody paddingBottom="16px"> 
                            <PersonDetails
                                showResolution = {true} 
                                fullWidth = {fullWidth}
                                fullHeight = {fullHeight}
                                person = {person}
                            ></PersonDetails>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        )
    }
    return null;
}